// apps/admin/src/features/quotes/components/QuotesDetailPage.tsx
import { CustomerDataProvider } from '../context/CustomersContext';
import Customers from './Customers';
import { usePageLoadTracking } from '../../../hooks/usePerformanceTracking';


export default function CustomersPage() {
  usePageLoadTracking('customers-page');
  
  return (
    <CustomerDataProvider>
      <Customers />
    </CustomerDataProvider>
  );
}
